import { TOURNAMENT_TYPES_WITH_STANDINGS } from './tournament.config';

const isTournamentWithStandings = (
  tournamentBracket: TournamentBracket
): tournamentBracket is TournamentBracketWithStandings =>
  TOURNAMENT_TYPES_WITH_STANDINGS.includes(tournamentBracket.tournament_type);

export { isTournamentWithStandings };
